import { createReducer } from 'redux-act';

import {
  ACTIONS_NAMES_DICT,
  ENTITY_ACTIONS as ACTIONS,
} from 'state/actions/stations';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  archived: false,
};

export const stationsReducer = createReducer(
  {
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_INIT]]: () => ({
      ...initialState,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_SUCCESS]]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CREATE_ENTITY_INIT]]: (state) => ({
      ...state,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CREATE_ENTITY_SUCCESS]]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload.entity),
      loading: false,
      error: null,
      success: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CREATE_ENTITY_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.UPDATE_ENTITY_INIT]]: (state) => ({
      ...state,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.UPDATE_ENTITY_SUCCESS]]: (state, payload) => ({
      ...state,
      data: !state.data
        ? []
        : state.data.map((elem) => {
            if (elem.id === payload.id) {
              return payload.data;
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.UPDATE_ENTITY_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.ARCHIVE_ENTITY_INIT]]: (state) => ({
      ...state,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.ARCHIVE_ENTITY_SUCCESS]]: (state, payload) => ({
      ...state,
      data: state.data.filter((elem) => elem.id !== payload.id),
      loading: false,
      error: null,
      archived: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.ARCHIVE_ENTITY_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CLEAN_UP]]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      archived: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CLEAR_DATA_LOGOUT]]: () => ({
      ...initialState,
    }),
  },
  initialState
);
